import { API_ENDPOINT } from '../config';

export default function(orderId) {
    return fetch(`${API_ENDPOINT}/orders/${orderId}/`);
}
